/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { node, bool, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import CloseIcon from 'gfx/vector/close-icon.svg';

import styles from './modal-wrapper.scss';

/**
 * This is the ModalWrapper component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ModalWrapper extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    children: node.isRequired,
    hideModal: func.isRequired,
  };

  /**
   * Render ModalWrapper.
   *
   * @return {Object}
   */
  render() {
    const { children, hideModal } = this.props;

    return (
      <div className={styles.wrapper}>
        <button type="button" className={styles.bg} onClick={hideModal} />
        <div className={styles.modal}>
          <button type="button" className={styles.button} onClick={hideModal}>
            <CloseIcon className={styles.close} />
          </button>
          {children && children}
        </div>
      </div>
    );
  }
}

export default withRouter(ModalWrapper);
